"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Localization_1 = require("../../../../constants/Localization");
var i18n_1 = __importDefault(require("../../../../i18n"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../../features/languages/languageSlice");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var HeaderNavigation = function () {
    var _a, _b;
    var t = react_i18next_1.useTranslation('common').t;
    var location = react_router_dom_1.useLocation();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    return (react_1.default.createElement("ul", { className: styles_module_scss_1.default.navigation },
        react_1.default.createElement("li", null,
            react_1.default.createElement(react_router_dom_1.Link, { className: classnames_1.default(styles_module_scss_1.default.navigation_link, (_a = {},
                    _a[styles_module_scss_1.default.active] = location === null || location === void 0 ? void 0 : location.pathname.includes(Localization_1.SellPagePrefix[i18n_1.default.language].sell),
                    _a)), to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell +
                    Localization_1.SearchPageNavigation[currentLanguage].sell }, t('HEADER.Menu.Buy'))),
        react_1.default.createElement("li", null,
            react_1.default.createElement(react_router_dom_1.Link, { className: classnames_1.default(styles_module_scss_1.default.navigation_link, (_b = {},
                    _b[styles_module_scss_1.default.active] = location === null || location === void 0 ? void 0 : location.pathname.includes(Localization_1.SellPagePrefix[i18n_1.default.language].rent),
                    _b)), to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].rent +
                    Localization_1.SearchPageNavigation[currentLanguage].rent }, t('HEADER.Menu.Rent')))));
};
exports.default = HeaderNavigation;
